import { DistributorDevice } from "../_models/DistributorDevice";
import { TimeHelper } from "../../Everou/_helpers/TimeHelper";

export class DistributorDeviceMapper {
    static allServerToLocal(serverDevices = []) {
        return serverDevices.map(this.serverToLocal);
    }

    static serverToLocal(serverDevice) {
        return DistributorDevice({
            uid: serverDevice.uid,
            bluetoothId: serverDevice.bluetooth_id,
            multiIndex: serverDevice.multi_index,
            description: serverDevice.description,
            type: serverDevice.type,
            originalType: serverDevice.original_type,
            lastActivity: serverDevice.last_activity
                ? TimeHelper.serverStringToIsoString(serverDevice.last_activity)
                : null,
            locationId: serverDevice.location_id,
            locationName: serverDevice.location_name,
            roomName: serverDevice.room_name,
            locationAdminEmail: serverDevice.location_admin_email,
            warrantyStart: serverDevice.warranty_start
                ? TimeHelper.serverStringToIsoString(serverDevice.warranty_start)
                : null,
            status: serverDevice.status,
            isVirtual: serverDevice.is_virtual,
        });
    }
}